import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../../store/slices/userSlice";
import { pageRoutes } from "../../constants";
import SignInFlow from "../../components/Auth/SignInFlow";
import NewPasswordStep from "./NewPasswordStep";

// Sets a new password from the emailed link, then signs in with the same SMS code steps as login
export default function ResetPassword() {
  const navigate = useNavigate();
  const { key } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // The link is used up once the password is set, so going back continues at the login page
  const goToLogin = (error) => navigate(pageRoutes.LOGIN, { replace: true, state: { error } });

  return (
    <SignInFlow
      onRestart={goToLogin}
      renderFirstStep={({ submit, ...stepProps }) => (
        <NewPasswordStep
          {...stepProps}
          newPassword={newPassword}
          confirmPassword={confirmPassword}
          onNewPasswordChange={setNewPassword}
          onConfirmPasswordChange={setConfirmPassword}
          onSubmit={() => submit(resetPassword, { key, newPassword })}
        />
      )}
    />
  );
}
